var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"centered-column"},[_c('div',{staticClass:"centered"},[_c('span',[_vm._v(_vm._s(_vm.slide.text))]),_c('ul',_vm._l((_vm.slide.bullets),function(bullet,index){return _c('li',{key:index},[_vm._v(_vm._s(bullet.text))])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }